import logoAsset from "@/assets/logo.png.asset.json";

/**
 * The four-quadrant diamond brand mark, spinning — our waiting indicator.
 *
 * Every wait on the site uses this instead of a generic spinner. Pilots who ask
 * their device to reduce motion get the same mark holding still, breathing
 * gently, so nothing moves that shouldn't.
 */

const SIZES = {
  sm: "size-4",
  md: "size-8",
  lg: "size-14",
} as const;

export function BrandSpinner({
  size = "md",
  className = "",
  label = "Loading",
}: {
  size?: keyof typeof SIZES;
  className?: string;
  label?: string;
}) {
  return (
    <img
      src={logoAsset.url}
      alt=""
      aria-label={label}
      role="status"
      draggable={false}
      className={`brand-spinner ${SIZES[size]} shrink-0 select-none ${className}`}
    />
  );
}

/** A centred waiting state for a whole panel or page area. */
export function BrandLoading({
  line = "One moment…",
  className = "",
}: {
  line?: string;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-10 text-center ${className}`}
      aria-busy="true"
    >
      <BrandSpinner size="lg" />
      <p className="text-sm text-muted-foreground">{line}</p>
    </div>
  );
}
